<template>
  <div
    class="infinite-list"
    v-infinite-scroll="loadMore"
    infinite-scroll-distance="10"
    v-loading.fullscreen.lock="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    :style="{ height: this.clientHeight + 'px' }"
  >
    <div
      v-for="(item, index) in list"
      class="m-item"
      :key="index"
      @click="linkToArea(item)"
    >
      <div class="mi-right">
        <h4>{{ item.companyName }}</h4>
        <p>
          报名时间：<span>{{
            item.inTime | moment("YYYY/MM/DD HH:mm:ss")
          }}</span>
        </p>
        <p>
          展区：<span style="padding-right: 15px">{{ item.areaName }}</span>
          面积：<span>{{ item.area }}㎡</span>
        </p>
        <p>
          展会联系人：<span>{{ item.linkMan }}</span>
          <span v-if="item.linkMob">, {{ item.linkMob }}</span>
        </p>
      </div>
    </div>
    <div class="empty" v-if="finish">你已经到底了 ~</div>
    <div class="empty" v-if="empty">暂无数据</div>
  </div>
</template>

<script>
import { mapMutations, mapActions } from "vuex";
export default {
  data() {
    return {
      page: 0,
      size: 10,
      totalCount: 0,
      count: 0,
      list: [],
      finish: false, // 加载完成状态
      empty: false, // 空数据状态
      loading: true,
      clientHeight: 600, // 空数据状态
    };
  },
  created() {
    document.title = "选择展会";
    this.clientHeight = document.documentElement.clientHeight || 600;
  },
  methods: {
    ...mapMutations({
      setHostExhibition: "hostSetModule/setHostExhibition",
    }),
    ...mapActions({
      applyOMAllApplyCompanyByExhibitionId:
        "mobileBackend/applyOMAllApplyCompanyByExhibitionId",
    }),
    loadMore() {
      if (this.list.length && this.list.length >= this.totalCount) {
        this.finish = true;
        return;
      }
      this.page += 1;
      this.init();
    },
    async init() {
      let res = await this.applyOMAllApplyCompanyByExhibitionId({
        pageIndex: this.page,
        pageSize: this.size,
        exhibitionId: this.$route.query.exhibitionId,
      });
      if (res && res.items.length > 0) {
        if (this.page === 0) {
          this.list = [...res.items];
        } else {
          this.list = [...this.list, ...res.items];
        }
        this.totalCount = res.totalCount;
        if (this.list.length === 0) {
          this.empty = true;
        }
      }
      if (res) {
        this.loading = false;
      }
    },
    linkToArea(item) {
      console.log("选择的展会", item);
      this.$router.push(
        `/mobile-backend/ex-company-details?applyCompanyId=${item.id}&dePjNameGroupId=${item.dePjNameGroupId}&exhibitionId=${this.$route.query.exhibitionId}`
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.infinite-list {
  overflow: auto;
  padding: 15px 15px 0;
}

.m-item {
  min-height: 90px;
  background-color: #fff;
  border-radius: 10px;
  padding: 14px 19px 10px;
  display: flex;
  margin-bottom: 15px;

  .mi {
    &-right {
      width: 100%;

      h4 {
        font-size: 15px;
        font-weight: normal;
        color: #333;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-bottom: 10px;
      }

      p {
        font-size: 12px;
        color: #666;
        margin-bottom: 8px;

        span {
          color: #333;
        }
      }
    }
  }
}

.empty {
  line-height: 100px;
  text-align: center;
  color: #ccc;
}
</style>
